import fetchV2 from "auth/FetchInterceptorV2";
import { env } from "configs/EnvironmentConfig";
import fetch from "../auth/FetchInterceptor";

const holidayService = {};

holidayService.getHolidays = ({ params }) => {
  const columnFilter = params.columnFilter || {};

  const defaultFields = [
    "id",
    "maker_id",
    "maker_date",
    "checker_id",
    "checker_date",
    "from_date",
    "to_date",
    "name",
    "hub_id",
    "hub",
  ];

  return fetchV2({
    url: `${env.API_MSP}/holidays`,
    method: "get",
    params: {
      ...columnFilter,
      page: params.page || 1,
      "per-page": params.sizePerPage || 10,
      sort: params.sort || "-maker_date",
      keywords: params.keywords || "",
      expand: params.expand || "maker,checker",
      fields: params.fields || defaultFields.join(","),
      "filter[record_status]": "O",
    },
  });
};

holidayService.getAllHolidays = ({ params }) => {
  return fetch({
    url: `${env.API_MSP}/holidays`,
    method: "get",
    params: { ...params, sort: params.sort },
  });
};

// Detail Holiday
holidayService.detailHoliday = ({ holidayId }) => {
  return fetchV2({
    url: `${env.API_MSP}/holidays/${holidayId}`,
    method: "get",
  });
};

// Create Holiday
holidayService.createHoliday = data => {
  return fetchV2({
    url: `${env.API_MSP}/holidays`,
    method: "post",
    data: {
      ...data,
    },
  });
};

// Update Shipping Unit
holidayService.updateHoliday = ({ holidayId = undefined, ...data }) => {
  return fetchV2({
    url: `${env.API_MSP}/holidays/${holidayId}`,
    method: "put",
    data,
  });
};

// Delete Shipping Unit
holidayService.deleteHoliday = holidayId => {
  return fetchV2({
    url: `${env.API_MSP}/holidays/${holidayId}`,
    method: "delete",
  });
};

export default holidayService;
